<template lang="pug">
article.vue-page-story-show-root
  CommunityQPublishModal
  StoryEmailModal

  nav.story-header.container(data-spy="affix" data-offset-top="95")
    .row
      .col-md-6
        h1 {{ name }}

      .col-md-6.text-right
        .btn-group
          a.btn.btn-prominent.btn-info(@click="goBack()")
            i.fa.fa-arrow-left
            |
            | Back

          EditButton(:story-id="storyId" :hide-label="false")
          ExportButton(:story-id="storyId" :story-name="name" :hide-label="false")
          DuplicateButton(
            :story-id="storyId"
            :story-name="name"
          )

          template(v-if="!spiked")
            DeleteButton(
              :story-id="storyId"
              :story-name="name"
              @deleted="goBack"
            )

    .row
      .col-md-6
        p.server-path
          i.fa.fa-hdd-o
          |
          |
          a(v-if="open_folder_url" :href="open_folder_url")
            | {{ content_path }}
          span(v-else)
            | {{ content_path }}
      .col-md-6.text-right
        p.updated-at(title='Last modified')
          i.fa.fa-clock-o
          |
          | {{ lastUpdated }}

  .row
    .col-md-7
      LabelledValue(label="Slug" :value="slug")

      LabelledValue(label="Overline" :value="overline")

      LabelledValue(label="Headline" :value="headline")

      LabelledValue(label="Deck head" :value="drop_head")

      LabelledValue(label="Byline" :value="byline" :html="true")

      LabelledValue(label="Content" :value="content" :multi-line="true" :html="true")

      LabelledValue(label="Endnote" :value="endnote" :multi-line="true" :html="true")

      .panel.panel-default(v-show="showInfobox")
        .panel-heading
          h4
            | Breakout box
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledValue(label="Headline" :value="infobox_headline")
          LabelledValue(label="Text" :value="infobox_text" :multi-line="true" :html="true")

      .panel.panel-default(v-show="showPullQuote")
        .panel-heading
          h4
            | Pull Quotes
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledValue(label="Headline" :value="pullQuote.headline")
          LabelledValue(label="Quote" :value="pullQuote.quote" :multi-line="true")
          LabelledValue(label="Attribution" :value="pullQuote.attribution")

      .panel.panel-default(v-show="showCommunityQ")
        .panel-heading
          h4
            | Web
            |
            |
            i.fa.fa-angle-down
        .panel-body
          LabelledCheckbox(label="Featured" :value="featured")
          LabelledCheckbox(label="Free" :value="ispublic")
          LabelledCheckbox(label="Comments disabled" :value="comments_disabled")
          LabelledValue(label="Headline" :value="web_head")
          LabelledValue(label="Slug" :value="web_slug")
          LabelledValue(label="Summary" :value="web_summary" :multi-line="true" :html="true")
          LabelledValue(label="Body" :value="web_body" :multi-line="true" :html="true")
          LabelledValue(label="Keywords" :value="keywords")
          Publication(v-for="storyPub in Object.values(storyPublications)" :key="storyPub.id" :story-publication="storyPub")

    #media.col-md-5
      MediaIndex(:story-id="storyId" :read-only="true")

      hr

      .row
        .col-md-6
          LabelledValue(label="Status" :value="squeueTitle")

        .col-md-6
          LabelledValue(label="Pub date" :value="pub_date")

        .col-md-6
          LabelledValue(label="Print sections" :value="sectionTitles.join(', ')")

        .col-md-6
          LabelledValue(label="Owner" :value="userName")

        .col-md-6
          LabelledValue(label="Web categories" :value="webCategoryTitles.join(', ')")

      template(v-if="storyPlacements.length > 0")
        hr

        Label(text="Issues")
        ul.list-group
          Placement(
            v-for="placement in storyPlacements"
            :placement="placement"
            :key="placement.id"
          )

      hr

      Label(text="File storage locations")
      pre(v-for="path in [content_path].concat(customFoldersStore.allPaths)" :key="path")
        i.fa.fa-hdd-o
        | &nbsp;{{ path }}

      hr
      Label(text="Web Map locations")
      Locations(:story-id="storyId" :read-only="true")

      hr

      LabelledValue(label="Notes" :value="notes" :multi-line="true")

      template(v-if="currentUserStore.currentUser.show_advert_fields")
        hr

        LabelledCheckbox(label="Twitter feed" :value="twitter_feed")
        LabelledCheckbox(label="Tweet" :value="tweet")
        LabelledCheckbox(label="Google Search Ad" :value="google_search_ad")
        LabelledCheckbox(label="Outbrain Ad" :value="outbrain_ad")

        hr

      LabelledValue(label="Export fields" :value="exportFormatNames")
</template>

<script>
  import { sync } from 'vuex-pathify';
  import { mapGetters } from 'vuex';
  import { mapStores } from 'pinia'
  import { useCurrentUserStore } from '@/stores/current_user.js'
  import { useCustomFoldersStore } from '@/stores/custom_folders.js'
  import { useExportFormatsStore } from '@/stores/export_formats.js'
  import { useWebCategoriesStore } from '@/stores/web_categories'
  import { useSectionsStore } from '@/stores/sections'
  import EditButton from '@/components/stories/actions/edit_button.vue';
  import ExportButton from '@/components/stories/actions/export_button.vue';
  import DeleteButton from '@/components/stories/actions/delete_button.vue';
  import DuplicateButton from '@/components/stories/actions/duplicate_button.vue';
  import Label from '@/components/shared/label.vue';
  import Value from '@/components/shared/value.vue';
  import LabelledValue from '@/components/shared/labelled_value.vue';
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue';
  import Locations from '@/components/stories/form/locations/index.vue'
  import MediaIndex from '@/components/stories/form/media/index.vue'
  import Placement from '@/components/stories/placement/index.vue';
  import Publication from './publication.vue'
  import CommunityQPublishModal from '@/components/community_q/publish_modal.vue';
  import StoryEmailModal from '@/components/stories/email_modal.vue'
  import { storyRoute } from '@/utils/route_helpers.js'
  import { formatDateTime } from '@/utils/time_helpers.js'

  export default {
    components: {
      EditButton,
      ExportButton,
      DeleteButton,
      DuplicateButton,
      Label,
      Value,
      LabelledCheckbox,
      LabelledValue,
      Locations,
      MediaIndex,
      Placement,
      Publication,
      CommunityQPublishModal,
      StoryEmailModal
    },

    props: {
      storyId: {
        type: Number,
        required: true
      },
      issueId: {
        type: Number,
        required: false
      },
      pageId: {
        type: Number,
        required: false
      }
    },

    computed: {
      ...sync('story/*'),
      spiked: sync('story@spiked'),
      storyPublications: sync('storyPublications/storyPublications'),
      storyPlacements: sync('storyPlacements/storyPlacements'),
      pullQuote: sync('pullQuote'),
      ...mapGetters('squeues', { squeueForId: 'forId' }),
      ...mapGetters('storyMedia', { storyMedia: 'attachments' }),
      ...mapGetters('users', { userForId: 'forId' }),
      ...mapStores(
        useCurrentUserStore,
        useCustomFoldersStore,
        useExportFormatsStore,
        useSectionsStore,
        useWebCategoriesStore
      ),

      exportFormatNames() {
        const formats = this.exportFormatsStore.forIds(this.export_format_ids)

        return formats.map(format => format.name).join(', ')
      },

      name() {
        return this.headline ? this.headline : this.slug;
      },

      squeueTitle() {
        return this.squeueForId(this.squeue_id)?.title
      },

      sectionTitles() {
        return this.sectionsStore.forIds(this.section_ids).map(section => section.title)
      },

      userName() {
        return this.userForId(this.user_id)?.name
      },

      webCategoryTitles() {
        return this.webCategoriesStore.forIds(this.web_category_ids).map(({ title }) => title)
      },

      showCommunityQ() {
        return !!(
          this.web_head ||
          this.web_summary ||
          this.web_body ||
          this.web_category_ids.length > 0 ||
          this.keywords
        );
      },

      showInfobox() {
        return this.infobox_headline || this.infobox_text;
      },

      showPullQuote() {
        const { headline, quote, attribution } = this.pullQuote;

        return headline || quote || attribution;
      },

      lastUpdated() {
        return formatDateTime(this.updated_at);
      }
    },

    async mounted() {
      const id = this.storyId

      await this.$store.dispatch('story/fetch', { id: this.storyId })
      await this.$store.dispatch('story/fetchDependentData')
    },

    methods: {
      goBack() {
        this.$router.push(storyRoute({
          storyRoute: 'stories',
          issueRoute: 'issue',
          pageRoute: 'issuePage',
          router: this.$router
        }))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-group {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-left: auto;
    
    // Ensure button components display inline
    :deep(> *) {
      display: inline-block;
    }
  }
</style>
